"use client";
import { useTranslation } from "@/i18n/client";
import { JDILogin } from "@/lib/jdiClientUtils";
import { sendClickTrack } from "@/tracks/25157";

interface Props {
  shopInfoVO?: {
    shopId?: string;
  };
}
export default function SigninBtn({ shopInfoVO }: Props) {
  const { t } = useTranslation();

  const onClickLogin = () => {
    JDILogin.getInstance().openLoginDialog();
    sendClickTrack.Search_ProductList_Login({
      channelName: "Search_result",
      shopid: shopInfoVO?.shopId || "-100",
    });
  };
  return (
    <span style={{ marginLeft: "15px", color: "#1869f5", cursor: "pointer" }} onClick={onClickLogin}>
      {t("s.signIn")}
    </span>
  );
}
